import useSWR from "swr";

import { API_BASE } from "../config/api";
import { PrivilegeFilters } from "../types/crm";
import { FetchOptions, SWRType } from "../types/global";
import { authFetcher } from "../utils/auth-fetch";

const BASE = API_BASE.CUSTOMER_ADMIN;

const useCrmPrivileges = (
  autoFetch = false,
  options: FetchOptions | null = null,
  filters: PrivilegeFilters = {},
) => {
  let swrUrl = `${BASE}/privileges`;
  if (options?.fetchOne && options?.id) {
    swrUrl = `${BASE}/privileges/${options.id}`;
  }

  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? [swrUrl, filters] : null,
    ([url, queryParams]) => authFetcher("GET", url, null, queryParams),
    {
      onErrorRetry: (error) => {
        if (error.status === 404) return;
      },
    },
  );

  return {
    data,
    dataLoading,
    mutate,
    error,
  };
};

export default useCrmPrivileges;
